import * as React from 'react'
import filesize from 'filesize.js'
import { useTheme } from 'styled-components'

import Icon from '~/truck/icon'
import Label from '~/truck/label'
import notifier from '~/truck/notifier'

import { ButtonContainer, Container, FirstRow, WarningContainer } from './elements'

interface InputFileProps {
  onChange: (event: any) => void
  description: string
  disabled?: boolean
  supportingText?: string
  sizeLimit: number
  style?: React.CSSProperties
  className?: string
  accept: string
}

export function InputFile(props: InputFileProps) {
  const { onChange, description, disabled, supportingText, sizeLimit, accept, style, className } = props

  const fileSizeHumanFormat = filesize(sizeLimit, 0)

  const fileInputRef = React.useRef(null)

  const theme = useTheme()

  const handleClick = () => {
    if (disabled) {
      return
    }

    fileInputRef.current.click()
  }

  const handleChange = event => {
    const files = event.target.files

    if (!files[0] || files[0].size > sizeLimit) {
      notifier.error(`El archivo supera el máximo de ${fileSizeHumanFormat}`, { timeout: 5000 })

      return
    }

    onChange(event)

    fileInputRef.current.value = null
  }

  return (
    <Container className={className} style={style}>
      <ButtonContainer disabled={disabled} onClick={handleClick}>
        <input
          style={{
            display: 'none',
          }}
          accept={accept}
          type="file"
          ref={fileInputRef}
          onChange={handleChange}
        />
        <FirstRow>
          <Icon type="download" size="md" color="primary" />
          <Label $color="primary" $textStyle="h5Bold">
            Adjuntar archivos
          </Label>
        </FirstRow>
        <Label $textStyle="h6Regular" $color="grayscale60">
          {description}
        </Label>
      </ButtonContainer>
      {supportingText && (
        <WarningContainer>
          <Icon
            interactive={false}
            type="info"
            color="grayscale60"
            size="sm"
            style={{
              marginTop: theme.spacing.compact,
            }}
          />
          <Label as="span" $textStyle="h6Regular" $color="grayscale60">
            {supportingText}
          </Label>
        </WarningContainer>
      )}
    </Container>
  )
}
